import { charWidth, wrapText } from './cardSvg';
import { tint } from './previewCard';

const PAD = 14;
const FONT = 'Inter, system-ui, sans-serif';
const TEXT = { size: 15, line: 20 } as const;
/** eingeknickte Ecke unten rechts */
const FOLD = 18;
/** Schrift auf dem Papier: immer dunkel (die Zettelfarben sind hell, im dunklen Modus wie im hellen) */
const INK = '#2b2620';

const esc = (s: string): string => s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Zeilen eines Zettels der Größe w × h: Absätze bleiben, jeder wird umgebrochen; was nicht mehr passt, endet mit „…“. */
export function noteLines(text: string, w: number, h: number): string[] {
  const width = w - 2 * PAD;
  const maxLines = Math.max(1, Math.floor((h - 2 * PAD - TEXT.size) / TEXT.line) + 1);
  const lines = text.split(/\r?\n/).flatMap((para) => (para.trim() === '' ? [''] : wrapText(para, width, TEXT.size, Number.MAX_SAFE_INTEGER)));
  while (lines.length > 0 && lines.at(-1) === '') lines.pop();
  if (lines.length <= maxLines) return lines;
  const kept = lines.slice(0, maxLines);
  const perLine = Math.max(4, Math.floor(width / charWidth(TEXT.size, false)));
  kept[maxLines - 1] = `${kept[maxLines - 1]!.slice(0, perLine - 1).trimEnd()}…`;
  return kept;
}

/**
 * Notizzettel als SVG (Data-URI am Cytoscape-Knoten): Papier in seiner Farbe mit leichtem Schatten und eingeknickter Ecke, darauf der
 * Text; ohne Text der Platzhalter blass.
 */
export function noteSvg(text: string, color: string, w: number, h: number, placeholder: string): string {
  const edge = tint(color, '#000000', 0.22);
  const p: string[] = [];
  p.push(`<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">`);
  // Schatten, Papier, Knick
  p.push(`<path d="M4 5H${w - 1}V${h - FOLD}L${w - FOLD} ${h - 1}H4Z" fill="#000000" opacity="0.12"/>`);
  p.push(`<path d="M1 1H${w - 3}V${h - FOLD - 2}L${w - FOLD - 2} ${h - 3}H1Z" fill="${esc(color)}" stroke="${edge}" stroke-width="1.5" stroke-linejoin="round"/>`);
  p.push(`<path d="M${w - 3} ${h - FOLD - 2}H${w - FOLD + 2}Q${w - FOLD - 2} ${h - FOLD - 2} ${w - FOLD - 2} ${h - FOLD + 2}V${h - 3}Z" fill="${edge}" opacity="0.6"/>`);
  const lines = text.trim() ? noteLines(text, w - 2, h - FOLD / 2) : [placeholder];
  let y = PAD + TEXT.size;
  for (const line of lines) {
    if (line) p.push(`<text x="${PAD}" y="${y}" font-family="${FONT}" font-size="${TEXT.size}" fill="${INK}"${text.trim() ? '' : ' opacity="0.45"'}>${esc(line)}</text>`);
    y += TEXT.line;
  }
  p.push('</svg>');
  return p.join('');
}
